var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2375 2.5H9.7625C5.2125 2.5 2.5 5.2125 2.5 9.7625V20.225C2.5 24.7875 5.2125 27.5 9.7625 27.5H20.225C24.775 27.5 27.4875 24.7875 27.4875 20.2375V9.7625C27.5 5.2125 24.7875 2.5 20.2375 2.5ZM15 19.85C12.325 19.85 10.15 17.675 10.15 15C10.15 12.325 12.325 10.15 15 10.15C17.675 10.15 19.85 12.325 19.85 15C19.85 17.675 17.675 19.85 15 19.85ZM22.4 8.6C22.3375 8.75 22.25 8.8875 22.1375 9.0125C22.0125 9.125 21.875 9.2125 21.725 9.275C21.4975 9.37156 21.2464 9.39816 21.0037 9.35141C20.7611 9.30466 20.5378 9.18667 20.3625 9.0125C20.25 8.8875 20.1625 8.75 20.1 8.6C20.0358 8.44977 20.0018 8.28836 20 8.125C20 7.9625 20.0375 7.8 20.1 7.65C20.1625 7.4875 20.25 7.3625 20.3625 7.2375C20.65 6.95 21.0875 6.8125 21.4875 6.9C21.575 6.9125 21.65 6.9375 21.725 6.975C21.8 7 21.875 7.0375 21.95 7.0875C22.0125 7.125 22.075 7.1875 22.1375 7.2375C22.25 7.3625 22.3375 7.4875 22.4 7.65C22.4625 7.8 22.5 7.9625 22.5 8.125C22.5 8.2875 22.4625 8.45 22.4 8.6Z",
    fill: "#F2F2F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram_icon.2757cfd16923259aacb4bab1292ffe65.svg";
export { ForwardRef as ReactComponent };